import NotificationsAdapter from './base';

export default class Result extends NotificationsAdapter {
  modelNamePlural = 'results';
}
